import {z} from 'zod';
import {CreateCodeRequest} from '../api/generated/index.defs.ts';
import {nonEmptyString} from '../utils/zod.ts';

export const codeSchema = z.object({
  description: nonEmptyString(),
  codeClass: nonEmptyString(),
  inactive: z.boolean(),
  sortOrder: z.number(),
}) satisfies z.Schema<CreateCodeRequest>;
export type CodeSchema = z.TypeOf<typeof codeSchema>;
